import { NgModule } from '@angular/core';
import { TemplateContextGuardDirective } from './template-context-guard.directive';

@NgModule({
  imports: [TemplateContextGuardDirective],
  exports: [TemplateContextGuardDirective],
})
export class TemplateContextGuardModule {}
